import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TicketCompletionRequest } from "@app/models/dto/ticket-completion-request";
import { TicketCompletionResponse } from "@app/models/dto/ticket-completion-response";
import { ClientConfigService } from "@app/core/config/client-config.service";

@Injectable({
  providedIn: "root"
})
export class IntegrationService {
  private clientConfigService = inject(ClientConfigService);
  private http = inject(HttpClient);

  public async ticketCompletion(
    ticketCompletionRequest: TicketCompletionRequest
  ): Promise<TicketCompletionResponse> {
    const config = await this.clientConfigService.config;
    const result = await this.http
      .post(
        config.serviceUrl + "/api/v1/integration/ticket/completion",
        ticketCompletionRequest,
        {
          withCredentials: true
        }
      )
      .toPromise();
    return result as TicketCompletionResponse;
  }
}
